import React from 'react';
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";

export function DocumentIngredients(props) {
    return <>
        <h4 style={{ marginLeft: "20px" }} className="phraseSubHeader" >{props.localizations.Ingredients}</h4>
        {
            (props.standardDataResult && props.standardDataResult.total > 0) &&
            (<><h4 style={{ marginLeft: "40px" }} className="phraseValueHeader">{props.localizations.Standard}</h4>
                <Grid
                    className="sphera-grid"
                    style={{
                        height: '330px',
                        width: '95%',
                        marginLeft: "auto",
                        marginRight: "auto",
                        marginTop: "10px",
                        maxHeight: '380px'
                    }}
                    data={props.standardDataResult}
                    {...props.standardDataState}
                    onDataStateChange={props.standardDataStateChange}
                    sortable={true}
                    reorderable={true}
                    resizable={true}
                    scrollable="scrollable"
                    pageable={{
                        buttonCount: 4,
                        pageSizes: [25, 50, 100]
                    }}
                >
                    <Column
                        field="name"
                        minResizableWidth={100}
                        title={props.localizations.Name}
                        filter="text"
                    />
                    <Column
                        field="cas"
                        minResizableWidth={100}
                        title={props.localizations.CasNumber}
                        filter="text"
                    />
                    <Column
                        field="ec"
                        minResizableWidth={100}
                        title={props.localizations.EcNumber}
                        filter="text"
                    />
                    <Column
                        field="concentrationValue"
                        minResizableWidth={100}
                        title={props.localizations.ConcentrationValue}
                        filter="text"
                    />
                </Grid></>
            )
        }
        {
            (props.fullDataResult && props.fullDataResult.total > 0) &&
            (<><h4 style={{ marginLeft: "40px" }} className="phraseValueHeader">{props.localizations.FullFormula}</h4>
                <Grid
                    className="sphera-grid"
                    style={{
                        height: '330px',
                        width: '95%',
                        marginLeft: "auto",
                        marginRight: "auto",
                        marginTop: "10px",
                        maxHeight: '380px'
                    }}
                    data={props.fullDataResult}
                    {...props.fullDataState}
                    onDataStateChange={props.fullDataStateChange}
                    sortable={true}
                    reorderable={true}
                    resizable={true}
                    scrollable="scrollable"
                    pageable={{
                        buttonCount: 4,
                        pageSizes: [25, 50, 100]
                    }}
                >
                    <Column
                        field="name"
                        minResizableWidth={100}
                        title={props.localizations.Name}
                        filter="text"
                    />
                    <Column
                        field="cas"
                        minResizableWidth={100}
                        title={props.localizations.CasNumber}
                        filter="text"
                    />
                    <Column
                        field="ec"
                        minResizableWidth={100}
                        title={props.localizations.EcNumber}
                        filter="text"
                    />
                    <Column
                        field="concentrationValue"
                        minResizableWidth={100}
                        title={props.localizations.ConcentrationValue}
                        filter="text"
                    />
                </Grid></>
            )

        }
    </>;
}